import React from "react";
import PropTypes from "prop-types";
import IconHeart from "../icons/IconHeart";
import { Container } from "./styled/stream-item-like";

function StreamItemLike({ streamItemId, liked, disabled, setStreamItemLike }) {
  return (
    <Container
      active={liked}
      disabled={disabled}
      onClick={() =>
        !disabled && setStreamItemLike({ streamItemId, liked: !liked })
      }>
      <IconHeart />
    </Container>
  );
}

StreamItemLike.propTypes = {
  streamItemId: PropTypes.string.isRequired,
  liked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  setStreamItemLike: PropTypes.func.isRequired
};

export default StreamItemLike;
